import { render, staticRenderFns } from "./RegisterPopWindow.vue?vue&type=template&id=351b7d26&scoped=true&"
import script from "./RegisterPopWindow.vue?vue&type=script&lang=js&"
export * from "./RegisterPopWindow.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPopWindow.vue?vue&type=style&index=0&id=351b7d26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351b7d26",
  null
  
)

export default component.exports